import React from 'react';
import { useNotifications } from '../hooks/useNotifications';
import NotificationList from '../components/notifications/NotificationList';
import NotificationPreferences from '../components/notifications/NotificationPreferences';

const NotificationsPage: React.FC = () => {
  const { notifications, unreadCount, hasMore, loadMore, markAllRead, isLoading } = useNotifications();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-3xl mx-auto px-4 py-8 space-y-8">
        <section className="bg-white rounded-lg shadow-sm border border-gray-200">
          <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
            <h1 className="text-lg font-semibold text-gray-900">
              Notifications {unreadCount > 0 && <span className="text-sm text-gray-500">({unreadCount} unread)</span>}
            </h1>
            {unreadCount > 0 && (
              <button onClick={markAllRead} className="text-sm text-blue-600 hover:underline">Mark all read</button>
            )}
          </div>
          {isLoading && notifications.length === 0 ? (
            <p className="px-4 py-6 text-sm text-gray-500">Loading…</p>
          ) : (
            <NotificationList items={notifications} />
          )}
          {hasMore && (
            <button onClick={loadMore} className="w-full py-2 text-sm text-blue-600 hover:bg-gray-50 border-t border-gray-100">
              Load more
            </button>
          )}
        </section>

        <section className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
          <h2 className="text-lg font-semibold text-gray-900 mb-3">Notification preferences</h2>
          <NotificationPreferences />
        </section>
      </div>
    </div>
  );
};

export default NotificationsPage;
